export interface IShopilinkServiceModel {
  name: string;
  image: string;
  price: number;
  isActive: boolean;
}
